import { useBreakpointValue } from "@gluestack-ui/themed";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import {
  IModalOption,
  IModalTemplateType
} from "@repo/core/components/layout/ModalTemplate/types";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { useRef, useState } from "react";

export const EmergencyWithdrawConfirmController = () => {
  const { back, replace } = useNavigation();
  const [isValidatingCvv, setIsValidatingCvv] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { isMobile: isMobileDevice } = useDeviceType();
  const alertModalRef = useRef<IModalRefProps>(null);

  const handleConfirmCardCvv = () => {
    setIsValidatingCvv(true);
    setTimeout(() => {
      setIsValidatingCvv(false);
      alertModalRef.current?.open();
    }, 2000);
  };
  const handleSeeReceipt = () => {
    replace(ROUTES.emergencyWithdrawReceipt);
  };

  const handleGoToStart = () => {
    replace(ROUTES.home);
  };

  const alertOptions: IModalOption[] = [
    {
      label: "Voltar ao início",
      onPress: handleGoToStart,
      type: IModalTemplateType.success
    },
    {
      label: "Ver comprovante",
      type: IModalTemplateType.outline,
      onPress: handleSeeReceipt
    }
  ];
  return {
    back,
    isMobile,
    isMobileDevice,
    isValidatingCvv,
    handleConfirmCardCvv,
    alertModalRef,
    alertOptions
  };
};
